import { render, staticRenderFns } from "./LocalsHeader.vue?vue&type=template&id=56595c70&scoped=true"
import script from "./LocalsHeader.vue?vue&type=script&lang=js"
export * from "./LocalsHeader.vue?vue&type=script&lang=js"
import style0 from "./LocalsHeader.vue?vue&type=style&index=0&id=56595c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56595c70",
  null
  
)

export default component.exports